import React, { Component, PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';

import { subscribe, subscribeSuccess } from 'modules/subscriptions';
import 'styles/form.scss';

export const fields = [ 'name', 'email' ];

function validate(values, props) {
    const errors = {};
    if(!values.name) {
        errors.name = 'Required';
    }
    if (!values.email) {
        errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }
    return errors;
}

class SubscribeForm extends Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    submit(data) {
        let subscribeSuccess = this.props.subscribeSuccess;
        let resetForm = this.props.resetForm;
        subscribe(data.name, data.email).then(function(response) {
            subscribeSuccess();
            resetForm();
        });
    }

    render() {
        const {
            fields: { name, email },
            handleSubmit,
            resetForm,
            submitting,
            status
        } = this.props;
        return (<form onSubmit={handleSubmit(this.submit)}>
          <div>
            <label>Full Name</label>
            <div>
              <input type="text" placeholder="Full Name" {...name}/>
            </div>
            {name.touched && name.error &&
             <div className="input-errors">{name.error}</div>}
          </div>
          <div>
            <label>Email Address</label>
            <div>
              <input type="email" placeholder="Email Address" {...email}/>
            </div>
            {email.touched && email.error &&
             <div className="input-errors">{email.error}</div>}
          </div>
          <div>
            <button type="submit" disabled={submitting}>
              {submitting ? <i/> : <i/>} Submit
            </button>
          </div>
          {status === 'success' && <div className="form-footer success">
            Please check your email to confirm your subscription
          </div>}
          {status !== 'success' && <div className="form-footer">
          I will never share your email</div>}
        </form>

        );
    }
}

SubscribeForm.propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    subscribeSuccess: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        status: state.subscriptions.status
    };
}

function mapDispatchToProps(dispatch) {
  return {
    subscribeSuccess: bindActionCreators(subscribeSuccess, dispatch)
  };
}

export default reduxForm(
    {
        form: 'subscribeForm',
        fields,
        validate
    },
    mapStateToProps,
    mapDispatchToProps
)(SubscribeForm);



/** WEBPACK FOOTER **
 ** ./src/components/Forms/Subscribe.js
 **/